module.exports = __webpack_public_path__ + "img/phone_frame.43bec649.png";